export default __webpack_public_path__ + "static/media/ally_background_xl1.91ff8957.jpg";